<template>
  <div v-if="article" class="article-view">
    <div class="inner" v-if="article">
      <div
        class="general-content-main-container container container-s margin-auto margin-m-vertical l:margin-l-vertical">
        <div class="article-block border-radius">
          <ag-title
            v-if="article"
            class="text-center margin-auto-inline margin-l-bottom l:margin-2xl-bottom"
            align="center">
            {{ article.title }}
          </ag-title>
          <div v-if="article" class="general-article-content">
            <div v-for="section of article.sections">
              <content-blocks :content="section.content"></content-blocks>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading flex-middle flex-center" style="min-height: 50vh;" v-else>
      <spinner :size="5"></spinner>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    article: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss">
.article-block {
  @media (min-width: 767px) {
    padding-inline: var(--margin-max);
    padding-bottom: var(--margin-max);
    padding-top: var(--margin-2xl);
    border: 1px solid var(--c-bg-4);
    background-color: var(--c-bg-5);
  }
}
.general-content-main-container {
  @media (max-width: 767px) {
    border: 1px solid var(--c-bg-4);
    background-color: var(--c-bg-5);
    padding-bottom: var(--margin-2xl);
    padding-top: var(--margin-xl);
  }
}
.general-article-content {
  p {
    line-height: 1.55;
  }
}
</style>
